import './NoPrint.css'
export const NoPrint = ({ children }) => {
  return (
    <div className="no-print">
      {children}
    </div>
  )
}
